import { Checkbox, Switch, SwitchSizes, mergeClassNames } from '@clockout-dev/design-elements';
import styles from './styles/configurationCard.module.scss';

/**
 * Stateless helpers used by `ConfigurationCard`. The controller owns the
 * decision of which toggle widget (`Checkbox` or `Switch`) to materialize for
 * the header's `action` slot, so the dumb `ConfigurationCardHeader` doesn't
 * have to know about toggle variants — callers only pass `toggleType` on the
 * card and get the right element placed in the header.
 */
class ConfigurationCardController {
    isCardDisabled() {
        const { disabled, onToggleEnabled, enabled } = this.props;
        if (typeof disabled === 'boolean') return disabled;
        return typeof onToggleEnabled === 'function' && enabled === false;
    }

    buildToggleAction() {
        const { onToggleEnabled, enabled, toggleType = 'checkbox' } = this.props;
        if (typeof onToggleEnabled !== 'function') return null;
        const handleChange = () => onToggleEnabled();

        if (toggleType === 'switch') {
            return (
                <Switch
                    checked={!!enabled}
                    onChange={handleChange}
                    size={SwitchSizes.SMALL}
                    classNames={{ switch: styles.cardHeaderSwitch }}
                />
            );
        }
        return <Checkbox classNames={{ label: styles.checkboxLabel}} checked={!!enabled} onChange={handleChange} />;
    }

    buildHeaderClassNames() {
        const { togglePosition = 'trailing' } = this.props;
        // `ConfigurationCardHeader` owns `cardHeader`; only pass layout modifiers.
        return togglePosition === 'leading' ? styles.cardHeaderLeading : undefined;
    }

    buildCardClassName() {
        const isDisabled = this.isCardDisabled();
        return mergeClassNames([
            styles.configurationCard,
            ...(isDisabled ? [styles.configurationCardDisabled] : [])
        ]);
    }

    buildBodyClassName() {
        const isDisabled = this.isCardDisabled();
        return mergeClassNames([
            styles.cardBody,
            ...(isDisabled ? [styles.cardBodyDisabled] : [])
        ]);
    }
}

export default ConfigurationCardController;
